import { lazyLoad } from 'app/utils/loadable';

export const Meters = lazyLoad(
  () => import('./meters'),
  (module) => module.Meters
);
